"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MoveToInboxOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MoveToInboxOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a.5.5 0 0 0-.5.5v5.293L5.354 3.646a.5.5 0 1 0-.708.707l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.707L8.5 5.793V.5A.5.5 0 0 0 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.94 5.06.44.44h-.826a.5.5 0 0 0-.424.235L1.402 8.5H5A1.5 1.5 0 0 1 6.5 10a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5A1.5 1.5 0 0 1 11 8.5h3.598L12.87 5.735a.5.5 0 0 0-.424-.235h-.825l.44-.44c.163-.164.281-.356.353-.56h.032a1.5 1.5 0 0 1 1.272.705l2.206 3.53A.5.5 0 0 1 16 9v5.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5V9a.5.5 0 0 1 .076-.265l2.206-3.53A1.5 1.5 0 0 1 3.554 4.5h.032c.072.204.19.396.353.56ZM15 9.5h-4a.5.5 0 0 0-.5.5A1.5 1.5 0 0 1 9 11.5H7A1.5 1.5 0 0 1 5.5 10a.5.5 0 0 0-.5-.5H1v5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MoveToInboxOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MoveToInboxOutline;
exports["default"] = _default;